import { render, staticRenderFns } from "./Processo.vue?vue&type=template&id=6142c5aa&"
import script from "./Processo.vue?vue&type=script&lang=js&"
export * from "./Processo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports